import { createSlice } from "@reduxjs/toolkit";
import { ContactMessagesState } from "../../types/contactMessages";
import {
  getAllContactMessages,
  getSingleContactMessage,
  replyToContactMessage,
} from "../thunk";

const initialState: ContactMessagesState = {
  messages: [],
  currentMessage: null,
  loading: false,
  error: null,
  count: 0,
};

const contactMessagesSlice = createSlice({
  name: "contactMessages",
  initialState,
  reducers: {
    clearContactMessagesError: (state) => {
      state.error = null;
    },
    clearCurrentMessage: (state) => {
      state.currentMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Get All Messages
      .addCase(getAllContactMessages.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllContactMessages.fulfilled, (state, action) => {
        state.loading = false;
        state.messages = action.payload.data;
        state.count = action.payload.count;
      })
      .addCase(getAllContactMessages.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Get Single Message
      .addCase(getSingleContactMessage.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSingleContactMessage.fulfilled, (state, action) => {
        state.loading = false;
        state.currentMessage = action.payload.data;
      })
      .addCase(getSingleContactMessage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Reply To Message
      .addCase(replyToContactMessage.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(replyToContactMessage.fulfilled, (state, action) => {
        state.loading = false;
        state.currentMessage = action.payload.data;
        // Update the message in the list as well
        const index = state.messages.findIndex((m) => m._id === action.payload.data._id);
        if (index !== -1) {
          state.messages[index] = action.payload.data;
        }
      })
      .addCase(replyToContactMessage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearContactMessagesError, clearCurrentMessage } =
  contactMessagesSlice.actions;
export default contactMessagesSlice.reducer;
